import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { EditOrganizationProfileModal } from 'works/legacy/components/edit-organization-profile';
import { Gap, Icon } from '@common/components';

export default function EditEmployeeId({
  employeeId,
  organizationProfileId,
  canUpdate,
}) {
  const [showOrganizationProfileModal, setShowOrganizationProfileModal] =
    useState(false);
  const openEditModalOnClick = (children) => (
    <a onClick={() => setShowOrganizationProfileModal(true)}>{children}</a>
  );

  return (
    <>
      <EditOrganizationProfileModal
        visible={showOrganizationProfileModal}
        onClose={() => setShowOrganizationProfileModal(false)}
        organizationProfileId={organizationProfileId}
      />
      <Gap align="center" className="sentry-mask">
        <Icon
          icon="idCardAlt"
          kind="light"
          size="sm"
          tooltipText="Employee ID"
        />

        {employeeId ? (
          <>
            {'EID: '}
            {canUpdate ? openEditModalOnClick(employeeId) : employeeId}
          </>
        ) : (
          canUpdate && openEditModalOnClick('Employee ID')
        )}
      </Gap>
    </>
  );
}

EditEmployeeId.propTypes = {
  employeeId: PropTypes.string,
  organizationProfileId: PropTypes.string.isRequired,
  canUpdate: PropTypes.bool,
};

EditEmployeeId.defaultProps = {
  canUpdate: false,
};
